export const ElECTRON_CUSTOM_TITLEBAR_HEIGHT = 30
// export const ELECTRON_WINDOWS_RADIUS = 12

export const readableContentMaxWidthClassName =
  "max-w-[clamp(45ch,60vw,65ch)] print:max-w-[calc(100vw-2rem)]"
